import { Immutable } from "immer";
import React from "react";

import type { ValuePropBlock as Value } from "@reactivated";

import { RichTextBlock } from "@thelabnyc/thelabui/src/components/RichText";

type Props = Immutable<{
    value: Value;
}>;

/**
 * React port of the pillows-specific ``ValuePropBlock`` (defined in
 * ``server/cms/components/homepage_value_prop.py``). DOM mirrors the
 * legacy Django template ``cms/components/homepage_value_prop.html``
 * exactly — featured image + intro copy + thumbnail list + CTA link.
 *
 * The featured image is rendered as a real ``<img>`` (matching the
 * legacy template); the per-thumbnail icons use a CSS
 * ``background-image`` on a ``<div>``, also matching the legacy markup.
 */
export const ValuePropBlock = (props: Props): React.JSX.Element => {
    const v = props.value;
    const imageUrl = v.image?.url ?? "";
    const linkUrl = v.link?.url ?? "";
    const detailThumbnails = v.detail_thumbnails ?? [];
    return (
        <div className="value-prop-bar value-prop-bar--pillows">
            <div className="l-capped-width">
                <div className="l-capped-width section-info-nasa">
                    <div className="section-info-nasa__image">
                        <img
                            alt=""
                            className="responsive-img"
                            src={imageUrl}
                            loading="lazy"
                            decoding="async"
                        />
                    </div>
                    <div className="section-info-nasa__copy">
                        <div className="section-info-nasa__copy-title u-text-uppercase">
                            <RichTextBlock value={v.title ?? ""} />
                        </div>
                        <div className="section-info-nasa__copy-description">
                            <RichTextBlock value={v.description ?? ""} />
                        </div>
                    </div>
                </div>
                <ul className="l-capped-width value-prop-list value-prop-list--pillows-home pdp-value-prop-bar__list">
                    {detailThumbnails.map((item, i) => {
                        const thumbUrl = item.image?.url ?? "";
                        return (
                            <li
                                key={i}
                                className="value-prop-list-item value-prop-list-item--pillows-home"
                            >
                                <div className="value-prop-list-item__icon value-prop-list-item__icon--pillows-home">
                                    <div
                                        className="value-prop-list-icon value-prop-list-icon--pillows-home"
                                        style={{
                                            backgroundImage: `url(${thumbUrl})`,
                                        }}
                                    ></div>
                                </div>
                                <div className="value-prop-list-item__copy value-prop-list-item__copy--pillows-home">
                                    <div className="value-prop-list-item__title value-prop-list-item__title--pillows-home u-text-uppercase ">
                                        <RichTextBlock
                                            value={item.title ?? ""}
                                        />
                                    </div>
                                    <div className="value-prop-list-item__subtitle value-prop-list-item__subtitle--pillows-home">
                                        <RichTextBlock
                                            value={item.description ?? ""}
                                        />
                                    </div>
                                </div>
                            </li>
                        );
                    })}
                </ul>
                <div className="value-prop-list__button">
                    <a
                        className="hp-value-prop-list__button-link"
                        href={linkUrl}
                    >
                        <div className="button button-lochmara-pillows button-lochmara-pillows--value-prop u-text-uppercase">
                            {v.link_name ?? ""}
                        </div>
                    </a>
                </div>
            </div>
        </div>
    );
};
